import React from 'react';
import { Box, Card, CardBody, Grid, Heading, Spinner, Text } from '@chakra-ui/react';

const SummaryCards = ({
  memberSummaryLoading,
  memberSummary,
  selectedMember,
  memberLabels,
  DASHBOARD_TYPE,
  DASHBOARD_SURFACE,
  surfaceCard,
  formatNumber,
  formatCurrency,
  formatPercentage,
}) => {
  return (
    <Card {...surfaceCard}>
      <CardBody>
        <Heading fontSize={DASHBOARD_TYPE.cardHeading} mb={4} color="rgba(0, 0, 0, 0.78)" borderBottom="1px solid rgba(0,0,0,0.08)" pb={2}>
          Summary
        </Heading>
        {memberSummaryLoading ? (
          <Spinner />
        ) : memberSummary ? (
          <Grid
            templateColumns={
              selectedMember === 'RETAIL'
                ? { base: '1fr', md: 'repeat(2, minmax(0, 1fr))', lg: '0.85fr 1.35fr 0.8fr 1.35fr 0.8fr 0.85fr' }
                : { base: '1fr', md: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(6, minmax(0, 1fr))' }
            }
            gap={2.5}
          >
            <Box p={3.5} minH="84px" borderRadius="12px" bg={DASHBOARD_SURFACE.cardBg} border={`1px solid ${DASHBOARD_SURFACE.border}`}>
              <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Total Num of Trx</Text>
              <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                {formatNumber(memberSummary.total_orders || 0)}
              </Text>
            </Box>
            <Box p={3.5} minH="84px" borderRadius="12px" bg={DASHBOARD_SURFACE.cardBg} border={`1px solid ${DASHBOARD_SURFACE.border}`}>
              <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Total Gross Amount</Text>
              <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                {formatCurrency(memberSummary.total_gross_amount || 0)}
              </Text>
            </Box>
            <Box p={3.5} minH="84px" borderRadius="12px" bg={DASHBOARD_SURFACE.cardBg} border={`1px solid ${DASHBOARD_SURFACE.border}`}>
              <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Total {memberLabels.actorLabel}</Text>
              <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                {formatNumber(selectedMember === 'RETAIL' ? memberSummary.total_customers || 0 : memberSummary.total_cashiers || 0)}
              </Text>
            </Box>
            <Box p={3.5} minH="84px" borderRadius="12px" bg={DASHBOARD_SURFACE.cardBg} border={`1px solid ${DASHBOARD_SURFACE.border}`}>
              <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Total Net Amount</Text>
              <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                {formatCurrency(memberSummary.total_net_amount || 0)}
              </Text>
            </Box>
            {selectedMember === 'RETAIL' && (
              <>
                <Box p={3.5} minH="84px" borderRadius="12px" bg={DASHBOARD_SURFACE.cardBg} border={`1px solid ${DASHBOARD_SURFACE.border}`}>
                  <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Usage Ratio</Text>
                  <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatPercentage(0)}
                  </Text>
                </Box>
                <Box p={3.5} minH="84px" borderRadius="12px" bg={DASHBOARD_SURFACE.cardBg} border={`1px solid ${DASHBOARD_SURFACE.border}`}>
                  <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Avg Disc Rate</Text>
                  <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatPercentage((memberSummary.total_gross_amount || 0) > 0 ? (((memberSummary.total_gross_amount || 0) - (memberSummary.total_net_amount || 0)) / (memberSummary.total_gross_amount || 0) * 100) : 0)}
                  </Text>
                </Box>
              </>
            )}
            {selectedMember === 'AVIATION_SERVICES' && (
              <>
                <Box p={3} borderRadius="12px" bg="rgba(0,0,0,0.02)" border="1px solid rgba(0,0,0,0.06)">
                  <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Total Quantity</Text>
                  <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatNumber(memberSummary.total_quantity || 0)}
                  </Text>
                </Box>
                <Box p={3} borderRadius="12px" bg="rgba(0,0,0,0.02)" border="1px solid rgba(0,0,0,0.06)">
                  <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.600">Total Discount</Text>
                  <Text fontSize={DASHBOARD_TYPE.kpiNumber} fontWeight="700" color="rgba(0,0,0,0.85)" whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatCurrency(memberSummary.total_discount || 0)}
                  </Text>
                </Box>
              </>
            )}
          </Grid>
        ) : (
          <Text color="gray.500" textAlign="center" py={8}>
            No data available
          </Text>
        )}
      </CardBody>
    </Card>
  );
};

export default SummaryCards;
